// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__S9Nei"};